import { changelog, versionRows } from '@/pages/home/data';

export default function VersionPanel() {
  return (
    <section id="version" className="scroll-mt-20 bg-background-100">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-[1.15fr_1fr] gap-6 lg:gap-8">
          <div className="bg-foreground-950 rounded-2xl p-6 md:p-8 text-background-50">
            <div className="flex items-center justify-between gap-4 flex-wrap">
              <div>
                <p className="text-xs font-medium tracking-[0.24em] text-primary-300">LATEST VERSION</p>
                <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl">
                  最新版本 <span className="text-accent-400">v5.8.2</span>
                </h2>
              </div>
              <span className="inline-flex items-center gap-1.5 h-8 px-3 rounded-full bg-secondary-500/20 text-secondary-300 text-xs font-medium">
                <i className="ri-verified-badge-line"></i>
                官方正式版
              </span>
            </div>

            <dl className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-0">
              {versionRows.map((row) => (
                <div
                  key={row.label}
                  className="flex items-center justify-between gap-4 py-3 border-b border-background-50/10"
                >
                  <dt className="text-sm text-background-300">{row.label}</dt>
                  <dd className="text-sm font-medium text-background-50 text-right">{row.value}</dd>
                </div>
              ))}
            </dl>

            <a
              href="#download"
              className="mt-7 inline-flex items-center gap-2 h-11 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-download-2-line text-lg"></i>
              下载最新版本安装包
            </a>
          </div>

          <div className="bg-background-50 border border-background-200 rounded-2xl p-6 md:p-8">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-accent-100 text-accent-800 flex items-center justify-center">
                <i className="ri-history-line text-lg"></i>
              </span>
              <h3 className="font-heading font-bold text-lg text-foreground-950">本次更新内容</h3>
            </div>
            <ol className="mt-5 space-y-4">
              {changelog.map((item, index) => (
                <li key={item} className="flex gap-3">
                  <span className="shrink-0 w-6 h-6 rounded-full bg-accent-100 text-accent-800 text-xs font-bold flex items-center justify-center">
                    {index + 1}
                  </span>
                  <p className="text-sm leading-relaxed text-foreground-600">{item}</p>
                </li>
              ))}
            </ol>
            <p className="mt-6 text-xs text-foreground-400 leading-relaxed">
              提示：旧版本可能出现下载入口失效的情况，建议保持为最新版本以获得更稳定的安装体验。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}